import { useState } from 'react';
import { Table, Form, OverlayTrigger, Tooltip, Dropdown, Button, Modal, Row, Col, Offcanvas, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import Flatpickr from 'react-flatpickr';
import { Link } from 'react-router-dom';

const ProjectTeams = ({ projectId, projectName }) => {
    const [show, setShow] = useState(false);
    const [showDelete, setShowDelete] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedSkills, setSelectedSkills] = useState(null);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedTeamLead, setSelectedTeamLead] = useState(null);
    const [selectedManager, setSelectedManager] = useState(null);
    const [selectedExperience, setSelectedExperience] = useState(null);
    const [joiningDate, setJoiningDate] = useState(new Date());
    const [joiningDateRange, setJoiningDateRange] = useState([null, null]);
    const [nameFilter, setNameFilter] = useState('');
    const [emailFilter, setEmailFilter] = useState('');
    const [phoneFilter, setPhoneFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);

    const statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
    ];

    const roleOptions = [
        { value: 'frontend-dev', label: 'Frontend Developer' },
        { value: 'backend-dev', label: 'Backend Developer' },
        { value: 'ui-designer', label: 'UI Designer' },
        { value: 'ux-designer', label: 'UX Designer' },
        { value: 'project-manager', label: 'Project Manager' },
        { value: 'team-lead', label: 'Team Lead' },
        { value: 'qa-engineer', label: 'QA Engineer' },
        { value: 'devops-engineer', label: 'DevOps Engineer' }
    ];

    const skillsOptions = [
        { value: 'react', label: 'React' },
        { value: 'angular', label: 'Angular' },
        { value: 'vue', label: 'Vue.js' },
        { value: 'nodejs', label: 'Node.js' },
        { value: 'python', label: 'Python' },
        { value: 'java', label: 'Java' },
        { value: 'php', label: 'PHP' },
        { value: 'aws', label: 'AWS' },
        { value: 'docker', label: 'Docker' },
        { value: 'kubernetes', label: 'Kubernetes' }
    ];

    const departmentOptions = [
        { value: 'frontend', label: 'Frontend' },
        { value: 'backend', label: 'Backend' },
        { value: 'design', label: 'Design' },
        { value: 'product', label: 'Product' },
        { value: 'marketing', label: 'Marketing' },
    ];

    const teamLeadOptions = [
        { value: 'john-doe', label: 'John Doe' },
        { value: 'jane-smith', label: 'Jane Smith' },
        { value: 'mike-johnson', label: 'Mike Johnson' }
    ];

    const managerOptions = [
        { value: 'sarah-wilson', label: 'Sarah Wilson' },
        { value: 'david-brown', label: 'David Brown' },
        { value: 'emily-davis', label: 'Emily Davis' }
    ];

    const experienceOptions = [
        { value: 'Freshers', label: 'Freshers' },
        { value: '0', label: '0 years' },
        { value: '1', label: '1 years' },
        { value: '2', label: '2 years' },
        { value: '3', label: '3 years' },
        { value: '4', label: '4 years' },
        { value: '5', label: '5 years' },
        { value: '6', label: '6 years' },
        { value: '7', label: '7 years' },
        { value: '8', label: '8 years' },
        { value: '9', label: '9 years' },
        { value: '10', label: '10 years' },
        { value: '11', label: '11 years' },
        { value: '12', label: '12 years' },
        { value: '13', label: '13 years' },
        { value: '14', label: '14 years' },
        { value: '15', label: '15 years' },
        { value: '16', label: '16 years' },
        { value: '17', label: '17 years' },
        { value: '18', label: '18 years' },
        { value: '19', label: '19 years' },
        { value: '20', label: '20 years' },
        { value: '21', label: '21 years' },
        { value: '22', label: '22 years' },
        { value: '23', label: '23 years' },
        { value: '24', label: '24 years' },
        { value: '25+', label: '25+ years' }
    ];

    const handleClose = () => {
        setShow(false);
        setSelectedRole(null);
        setSelectedSkills(null);
        setSelectedDepartment(null);
        setSelectedTeamLead(null);
        setSelectedManager(null);
        setSelectedExperience(null);
        setJoiningDate(new Date());
    };
    const handleShow = () => setShow(true);

    const handleDeleteClose = () => setShowDelete(false);
    const handleDeleteShow = () => setShowDelete(true);
    
    const handleDelete = () => {
        // TODO: Integrate with API - Delete team member from project
        console.log('Deleting team member from project:', projectId);
        handleDeleteClose();
    };

    const handleAddPerson = () => {
        // TODO: Integrate with API - Add person to project team
        console.log('Adding person to project:', projectId);
        handleClose();
    };

    const handleApplyFilters = () => {
        // TODO: Integrate with API - Filter project team members
        console.log('Applying filters for project:', projectId, {
            name: nameFilter,
            email: emailFilter,
            phone: phoneFilter,
            role: selectedRole,
            department: selectedDepartment,
            skills: selectedSkills,
            teamLead: selectedTeamLead,
            experience: selectedExperience,
            joiningDateRange: joiningDateRange,
            status: statusFilter
        });
        setShowFilter(false);
    };

    return (
        <>
            <div className='c-card-1'>
                <div className='c-card-header-1'>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <div>
                            Team Members
                        </div>
                        <div className='d-flex align-items-center gap-1'>
                            <Button variant='outline-primary' 
                                className='btn-sm me-2 text-nowrap'
                                onClick={() => setShowFilter(true)}
                            >
                                <i className="fas fa-filter me-1"></i>
                                Filter
                            </Button>
                            <Button variant='primary' onClick={handleShow}
                                className='btn-sm text-nowrap'
                            >
                                <i className="fas fa-plus me-1"></i>
                                Add People
                            </Button>
                        </div>
                    </div>
                </div>
                <div className='c-card-body-1 p-0'>
                    <Table responsive className='c-table'>
                        <thead>
                            <tr>
                                <th width="50px" className='text-center'>
                                    <Form.Check />
                                </th>
                                <th>Name</th>
                                <th width="120px" className='text-center'>Chat & Email</th>
                                <th width="120px" className='text-center'>Role</th>
                                <th width="120px" className='text-center'>Billable Target</th>
                                <th width="180px" className='text-center'>Projects Assigned</th>
                                <th width="60px" className='text-center'>Reporting TeamLead</th>
                                <th width="60px" className='text-center'>Reporting Manager</th>
                                <th width="120px" className='text-center'>Status</th>
                                <th width="50px" className='text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...Array(4)].map((_, i) => (
                                <tr key={i}>
                                    <td className='text-center'>
                                        <Form.Check />
                                    </td>
                                    <td>
                                        <div className='d-flex align-items-center'>
                                            <Button variant="link" className='me-3'>
                                                <i className="fas fa-chevron-right"></i>
                                            </Button>
                                            <div className='d-flex align-items-center'>
                                                <div className='c-avatar'>
                                                    <img src='https://randomuser.me/api/portraits/men/32.jpg' alt='Avatar' />
                                                </div>
                                                <div>
                                                    <div className='p-tag fw-bold'>John Doe</div>
                                                    <div className='p-tag fs-12'>Role: Team Lead | Department: Marketing</div>
                                                    <div className='p-tag fs-12'>Total Experience: 5 years | Joining Date: 14 March 2016</div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>Chat</Tooltip>}
                                            >
                                            <Link to="/messages" className='fs-18 mx-1 dark-text primary-link'>
                                                <i className="fa-regular fa-comment"></i>
                                            </Link>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>Email</Tooltip>}
                                            >
                                            <Link to="/messages" className='fs-18 mx-1 dark-text primary-link'>
                                                <i className="fa-regular fa-envelope"></i>
                                            </Link>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>Call</Tooltip>}
                                            >
                                            <Link to="/messages" className='fs-18 mx-1 dark-text primary-link'>
                                                <i className="fa-solid fa-phone"></i>
                                            </Link>
                                        </OverlayTrigger>
                                    </td>
                                    <td className='text-center'>
                                        Front End Developer
                                    </td>
                                    <td className='text-center'>100%</td>
                                    <td className='text-center'>
                                        <div className="d-flex flex-column align-items-start">
                                            <div className="p-tag fw-bold fs-12 mb-1">50%</div>
                                            <div className="c-progress-bar mb-1"><div className="c-progress-fill" style={{ width: '50%', background: 'linear-gradient(90deg, #34d399 0%, #10b981 100%)' }}></div></div>
                                            <div className="p-tag fs-12 d-flex justify-content-between w-100">
                                                <div>5 Completed</div>
                                                <div>10 Total</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>John Doe</Tooltip>}
                                            >
                                                <div className='c-avatar c-avatar-text c-avatar-sm me-0'>
                                                    JD
                                                </div>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>John Doe</Tooltip>}
                                            >
                                                <div className='c-avatar c-avatar-text c-avatar-sm me-0'>
                                                    JD
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className='d-flex align-items-center justify-content-center'>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip>John Doe</Tooltip>}
                                            >
                                                <div className='c-avatar c-avatar-text c-avatar-sm me-0'>
                                                    JD
                                                </div>
                                            </OverlayTrigger>
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <div className='c-form-switch'>
                                            <Form.Check
                                                type="switch"
                                                id={`custom-switch-${i}`}
                                                label=""
                                                onClick={handleDeleteShow}
                                            />
                                        </div>
                                    </td>
                                    <td className='text-center'>
                                        <Dropdown className='c-dropdown-1'>
                                            <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                <i className="fas fa-ellipsis-v"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={handleShow}><i className="fas fa-edit me-2"></i> Edit</Dropdown.Item>
                                                <Dropdown.Item onClick={handleDeleteShow}><i className="fas fa-trash me-2"></i> Remove</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                <div className='c-card-footer-1'>
                    <div className='d-flex justify-content-between align-items-center c-pagination'>
                        <div className="p-tag d-flex align-items-center text-nowrap">
                            Show
                            <select className="form-select mx-2" style={{ minWidth: 70 }}>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                            </select>
                            per page (20 total)
                        </div>
                        <div className='d-flex align-items-center gap-2 p-tag'>
                            <div className='text-nowrap'>1 to 11 of 20 Pages</div>
                            <select 
                                className='form-select' 
                                style={{ minWidth: 70 }}
                                id='page-select'
                            >
                                {[...Array(4)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>
                            <Button variant="btn">
                                <i className="fas fa-chevron-left"></i>
                            </Button>
                            <Button variant="btn">
                                <i className="fas fa-chevron-right"></i>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add/Edit Person Modal */}
            <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered  size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='display-1'>Add Team Member</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className='gy-3'>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Name <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="text" />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Email <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="client@example.com, admin@example.com" />
                                    <Form.Text className="fs-12">Enter multiple emails separated by commas.</Form.Text>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Phone <span className='text-danger'>*</span></Form.Label>
                                    <Form.Control type="text" placeholder="+1 (555) 123-4567, +1 (555) 123-4568" />
                                    <Form.Text className="fs-12">Enter multiple phone numbers separated by commas.</Form.Text>
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Total Experience <span className='text-danger'>*</span></Form.Label>
                                    <Select
                                        value={selectedExperience}
                                        onChange={setSelectedExperience}
                                        options={experienceOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Joining Date <span className='text-danger'>*</span></Form.Label>
                                    <Flatpickr
                                        value={joiningDate}
                                        onChange={([date]) => setJoiningDate(date)}
                                        className="form-control"
                                        options={{
                                            dateFormat: 'd M Y',
                                            maxDate: 'today',
                                            defaultDate: 'today',
                                            allowInput: true,
                                            disableMobile: true,
                                            enableTime: false,
                                            time_24hr: false,
                                            static: false,
                                            animate: true
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Role</Form.Label>
                                    <Select
                                        value={selectedRole}
                                        onChange={setSelectedRole}
                                        options={roleOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Department</Form.Label>
                                    <Select
                                        value={selectedDepartment}
                                        onChange={setSelectedDepartment}
                                        options={departmentOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Skills</Form.Label>
                                    <Select
                                        value={selectedSkills}
                                        onChange={setSelectedSkills}
                                        options={skillsOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Reporting TeamLead</Form.Label>
                                    <Select
                                        value={selectedTeamLead}
                                        onChange={setSelectedTeamLead}
                                        options={teamLeadOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={6}>
                                <Form.Group>
                                    <Form.Label>Reporting Manager</Form.Label>
                                    <Select
                                        value={selectedManager}
                                        onChange={setSelectedManager}
                                        options={managerOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Label>Working Hours</Form.Label>
                                <Row className='gy-3'>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Monday</Form.Label>
                                            <Form.Control type="number" defaultValue={8} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Tuesday</Form.Label>
                                            <Form.Control type="number" defaultValue={8} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Wednesday</Form.Label>
                                            <Form.Control type="number" defaultValue={8} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Thursday</Form.Label>
                                            <Form.Control type="number" defaultValue={8} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Friday</Form.Label>
                                            <Form.Control type="number" defaultValue={8} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Saturday</Form.Label>
                                            <Form.Control type="number" defaultValue={0} />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Sunday</Form.Label>
                                            <Form.Control type="number" defaultValue={0} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button variant="link" className='text-danger text-decoration-none' onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleAddPerson}>
                        Add Team Member
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete/Remove Confirmation Modal */}
            <Modal show={showDelete} onHide={handleDeleteClose} backdrop="static" keyboard={false} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title className='display-1'>Remove Team Member</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-tag mb-4">Are you sure you want to remove <strong>John Doe</strong> from the project <strong>{projectName}</strong>?</div>
                    <Form.Group className='mb-4'>
                        <Form.Label>Type <strong className='text-danger'>Remove</strong> to confirm. <span className='text-danger'>*</span></Form.Label>
                        <Form.Control type="text"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Reason for removal <span className='text-danger'>*</span></Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className='d-flex justify-content-between'>
                    <Button variant="link" className='text-danger text-decoration-none' onClick={handleDeleteClose}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Remove
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Filter Offcanvas */}
            <Offcanvas show={showFilter} onHide={() => setShowFilter(false)} placement="end">
                <Offcanvas.Header className='px-4 py-3' closeButton>
                    <Offcanvas.Title className='display-1'>Filter Team Members</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className='px-4 py-3'>
                    <Form>
                        <Row className='gy-2'>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={nameFilter}
                                        onChange={(e) => setNameFilter(e.target.value)}
                                        placeholder="Search by name..."
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        value={emailFilter}
                                        onChange={(e) => setEmailFilter(e.target.value)}
                                        placeholder="Search by email..."
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Phone</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        value={phoneFilter}
                                        onChange={(e) => setPhoneFilter(e.target.value)}
                                        placeholder="Search by phone..."
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Joining Date Range</Form.Label>
                                    <InputGroup>
                                        <Flatpickr
                                            value={joiningDateRange[0]}
                                            onChange={([date]) => setJoiningDateRange([date, joiningDateRange[1]])}
                                            className="form-control"
                                            options={{
                                                dateFormat: 'd M Y',
                                                maxDate: joiningDateRange[1] || 'today',
                                                allowInput: true,
                                                disableMobile: true,
                                                enableTime: false,
                                            }}
                                            placeholder="Start date"
                                        />
                                        <InputGroup.Text className="bg-light p-tag">to</InputGroup.Text>
                                        <Flatpickr
                                            value={joiningDateRange[1]}
                                            onChange={([date]) => setJoiningDateRange([joiningDateRange[0], date])}
                                            className="form-control"
                                            options={{
                                                dateFormat: 'd M Y',
                                                maxDate: 'today',
                                                minDate: joiningDateRange[0],
                                                allowInput: true,
                                                disableMobile: true,
                                                enableTime: false,
                                            }}
                                            placeholder="End date"
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Role</Form.Label>
                                    <Select
                                        value={selectedRole}
                                        onChange={setSelectedRole}
                                        options={roleOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Department</Form.Label>
                                    <Select
                                        value={selectedDepartment}
                                        onChange={setSelectedDepartment}
                                        options={departmentOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Skills</Form.Label>
                                    <Select
                                        value={selectedSkills}
                                        onChange={setSelectedSkills}
                                        options={skillsOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Reporting TeamLead</Form.Label>
                                    <Select
                                        value={selectedTeamLead}
                                        onChange={setSelectedTeamLead}
                                        options={teamLeadOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Experience Range</Form.Label>
                                    <Select
                                        value={selectedExperience}
                                        onChange={setSelectedExperience}
                                        options={experienceOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                        isMulti
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group>
                                    <Form.Label>Status</Form.Label>
                                    <Select
                                        value={statusFilter}
                                        onChange={setStatusFilter}
                                        options={statusOptions}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder=""
                                        isClearable
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Offcanvas.Body>
                <div className="p-3 border-top">
                    <div className="d-flex justify-content-between">
                        <Button variant="link" className='text-decoration-none' onClick={() => {
                            setSelectedRole(null);
                            setSelectedDepartment(null);
                            setSelectedSkills(null);
                            setSelectedTeamLead(null);
                            setSelectedExperience(null);
                            setJoiningDateRange([null, null]);
                            setNameFilter('');
                            setEmailFilter('');
                            setPhoneFilter('');
                            setStatusFilter(null);
                        }}>
                            Reset
                        </Button>
                        <Button variant="primary" onClick={handleApplyFilters}>
                            Apply Filters
                        </Button>
                    </div>
                </div>
            </Offcanvas>
        </>
    );
};

export default ProjectTeams;
